export function strToBool(value: string | undefined | null): boolean | undefined {
    return value === undefined || value === null ? undefined : value === 'true';
}

export function boolToStr(value: boolean | undefined | null): string | undefined {
    return value === undefined || value === null ? undefined : String(value);
}
